(function () {
  if (window.__nxHome) return;
  window.__nxHome = true;

  // Carousel arrows
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-nx-scroll]');
    if (!arrow) return;
    var root = arrow.closest('[data-nx-row]');
    var track = root && root.querySelector('[data-nx-track]');
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
    track.scrollBy({ left: arrow.dataset.nxScroll === 'next' ? step : -step, behavior: 'smooth' });
  });

  // Gentle reveal on scroll
  function initReveal() {
    var items = document.querySelectorAll('.nx-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
  document.addEventListener('shopify:section:load', initReveal);
})();